module.exports = __webpack_public_path__ + "img/shouye_bg.2b2e8086.png";